import { useQuery } from '@tanstack/react-query'

import { useApiClient } from '../client/apiClientContext'

export function useConfig() {
  const rf = useApiClient()
  return useQuery({ queryKey: ['config'], queryFn: () => rf((client) => client.GET('/app/config')) }).data
}
